import {Theme} from '@material-ui/core'
import {createStyles} from '@material-ui/core/styles'

const AIDementiaPredictionStyles = (theme: Theme) =>
  createStyles({
    heathTabs: {
      display: 'flex',
      fontFamily: 'Noto Sans KR',
      marginBottom: '20px',
    },
    heathTab: {
      border: '2px solid #a7a7a7',
      cursor: 'pointer',
      marginRight: 5,
      height: '50px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      fontWeight: 600,
      minWidth: 200,
      fontSize: '16px',
      padding: '0 18px',
      backgroundColor: '#F4F4F7',
    },
    heathTabActive: {
      color: '#ffffff',
      border: '2px solid #00A29C',
      backgroundColor: '#00A29C',
      fontWeight: 700,
    },
  })

export default AIDementiaPredictionStyles
